const baseCommon = typeof window !== 'undefined' && window.feConfig && window.feConfig.common;
const staticBaseUrl = (baseCommon && window.feConfig.common.staticBaseUrl) || 'https://stc.yxt.com/';

// 后台维护的字典键
export const dictionaryKeys = {
  user: 'user', // 学员
  integral: 'integral', // 积分
  credits: 'credits', // 学分
  exp: 'exp', // 经验值
  dateScope: 'dateScope', // 时间范围
  deptScope: 'deptScope', // 部门范围
  excludeUser: 'excludeUser', // 排除人员
  userName: 'userName', // 姓名
  userImgUrl: 'userImgUrl', // 头像
  deptName: 'deptName', // 部门名称
  orgName: 'orgName' // 平台名称
};

export const sspSvgCdn = `${staticBaseUrl}ufd/55a3e0/ssp/pc/svg/`;

export const sspImgCdn = `${staticBaseUrl}ufd/55a3e0/ssp/pc/img/`;

// 跳转用户中心
export const linkToUserIndex = userId => {
  if (userId) {
    window.location.href = `${window.location.protocol}//${
      window.location.host
    }/#/userindex?userId=${userId}`;
  }
};

// 格式化榜单数据 -- 保留两位小数，千 展示K、百万 展示M、十亿 展示B
export const numberUnit = value => {
  value = value ? Number(value) : 0; // 当前值
  const minus = value < 0 ? '-' : '';
  value = Math.abs(value);
  const decimals = 2; // 保留两位小数
  const units = [
    '',
    '',
    '',
    '',
    '0K',
    '00K',
    'M',
    '0M',
    '00M',
    'B'
  ]; // 每组进制单位
  const timesRule = { K: 3, M: 6, B: 9 }; // 单位对应10的几次方
  const overflowValue = 1000000000; // 溢出值，默认超出1B溢出
  const startIndex = 3; // 从指定索引开始显示单位，默认从万开始处理单位

  if (value === 0) return value;
  for (let i = units.length; i > startIndex; i--) {
    let unitNumber = Math.pow(10, i - 1);
    let surplus = value % unitNumber;
    let lastIndex = i === startIndex + 1;
    if (surplus !== value || lastIndex) {
      // 最终单位处理
      // 如果是最后一次循环，只需要取余
      let num = lastIndex ? value : value / unitNumber;
      if (
        overflowValue &&
        value > overflowValue &&
        i === units.length
      ) {
        // 如果需要溢出处理，且当前值已溢出，则处理成最大值
        // eslint-disable-next-line radix
        num = parseInt(overflowValue / unitNumber) + units[i - 1] + '+';
      } else {
        const times = units[i - 1].split('');
        const unit = times.pop() || '';
        if (times.length) {
          num *= Math.pow(10, times.length);
        }
        num = Math.floor(accMul(num, Math.pow(10, decimals))) / Math.pow(10, decimals);
        const isMore =
          value > num * Math.pow(10, timesRule[unit] || 1) ? '+' : '';
        if (!unit && (num + '').split('.')[0].length > 3) {
          const arr = (num + '').split('');
          arr.splice(1, 0, ',');
          num = arr.join('');
        }
        num += unit + isMore;
      }
      return minus + num;
    }
  }
};

function accMul(arg1, arg2) {
  let m = 0;
  const s1 = arg1.toString();
  const s2 = arg2.toString();
  try {
    m += s1.split('.')[1].length;
  } catch (e) {
  }
  try {
    m += s2.split('.')[1].length;
  } catch (e) {
  }
  return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m);
}

// 横排式 前三名的各类图片
export const horizontalHeadImgs = [
  {
    bg: 'rank_silver_bg.png', // 第二名
    crown: 'rank_silver_crown.png',
    order: 1
  },
  {
    bg: 'rank_golden_bg.png', // 第一名 背景图
    crown: 'rank_golden_crown.png', // 皇冠
    order: 0 // 名次
  },
  {
    bg: 'rank_copper_bg.png', // 第三名
    crown: 'rank_copper_crown.png',
    order: 2
  }
];

// 时间范围的各类选项
export const dateList = [
  {
    label: 'pc_biz_rank_total_time',
    text: '全部时间',
    type: 1,
    tip: 'pc_biz_rank_total',
    tipText: '总{0}'
  },
  {
    label: 'pc_biz_rank_year',
    text: '年',
    type: 2,
    tip: 'pc_biz_rank_this_year',
    tipText: '本年'
  },
  {
    label: 'pc_biz_rank_month',
    text: '月',
    type: 3,
    tip: 'pc_biz_rank_this_month',
    tipText: '本月'
  },
  {
    label: 'pc_biz_rank_week',
    text: '周',
    type: 4,
    tip: 'pc_biz_rank_this_week',
    tipText: '本周'
  }
];
